import React from "react";
import PropTypes from "prop-types";
import classcat from "classcat";

import "./subsidy-benefit-card.scss";

const SubsidyBenefitCard = ({
  title,
  image,
  active,
  handlerClick,
  disabled,
}) => {
  return (
    <button
      type="button"
      className={classcat([
        "subsidy-benefit-card",
        { selected: active, disabled },
      ])}
      onClick={handlerClick}
      disabled={disabled}
    >
      <img className="benefit-image" src={image} alt={image} />
      <div className="benefit-card-title">
        <p className="benefit-title">{title}</p>
      </div>
    </button>
  );
};

SubsidyBenefitCard.defaultProps = { active: false, disabled: false };
SubsidyBenefitCard.propTypes = {
  title: PropTypes.string.isRequired,
  image: PropTypes.string.isRequired,
  active: PropTypes.bool,
  handlerClick: PropTypes.func.isRequired,
  disabled: PropTypes.bool,
};

export default SubsidyBenefitCard;
